import getConfig from 'next/config';
import _ from '../../utils/LodashImports';
import { ANCHO, CATEGORY_ID, DIMENSIONABLE, DIMENSIONABLE_VALUES, LARGO, VALID_TENANTS } from './constants';

const getEnvironmentUrl = () => {
  const nextConfig = getConfig();
  const env = _.get(nextConfig, 'publicRuntimeConfig.ENVIRONMENT', 'production');
  const envMap = {
    production: 'prod',
    staging: 'stg',
    uat: 'beta',
  };
  return envMap[env] || 'prod';
};

export const getIframeBaseUrl = () => `https://falabella-woods-journey-${getEnvironmentUrl()}.firebaseapp.com/`;

export const getWoodCutOptimizerConfig = (
  tenant = '',
  product = {},
  { politicalId = '', priceGroupId = '', zones = '' } = {}
) => {
  if (!product || typeof product !== 'object') {
    return { iframeSrcUrl: '', showButton: false };
  }

  const { attributes = {}, id: productId = '', currentVariant: variantId = '' } = product;
  const { GSCCategoryId = '', specifications = [] } = attributes;

  if (!Array.isArray(specifications)) {
    return { iframeSrcUrl: '', showButton: false };
  }

  const lowerCasedTenant = (tenant || '').toLowerCase();
  const hasDimensionable = specifications.some(
    (spec) => spec?.name?.toLowerCase() === DIMENSIONABLE && DIMENSIONABLE_VALUES.includes(spec?.value?.toLowerCase())
  );
  const hasLargo = specifications.some((spec) => spec?.name?.toLowerCase() === LARGO);
  const hasAncho = specifications.some((spec) => spec?.name?.toLowerCase() === ANCHO);

  const isValidTenant = Object.values(VALID_TENANTS).includes(lowerCasedTenant);

  const showButton =
    !!(lowerCasedTenant && productId && variantId) &&
    isValidTenant &&
    (lowerCasedTenant === VALID_TENANTS.FACL
      ? GSCCategoryId === CATEGORY_ID && hasDimensionable && hasLargo && hasAncho
      : hasDimensionable && hasLargo && hasAncho);

  const iframeSrcUrl = showButton
    ? `${getIframeBaseUrl()}?tenant=${lowerCasedTenant}&productId=${productId}&variantId=${variantId}&zones=${zones}&priceGroup=${priceGroupId}&politicalId=${politicalId}`
    : '';

  return { iframeSrcUrl, showButton };
};
